var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-snackbar',{attrs:{"timeout":_vm.timeout,"fixed":"","top":"","right":"","color":_vm.color,"elevation":_vm.elevation},model:{value:(_vm.snackBarModel),callback:function ($$v) {_vm.snackBarModel=$$v},expression:"snackBarModel"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }